import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  DisablePayment,
  DisablePaymentPlatforms,
  DisablePaymentPlatformsVersion,
  DisablePaymentState,
} from 'types/disablePayment';

const initialState: DisablePaymentState = {
  isLoading: false,
  disablePayment: null,
};

const slice = createSlice({
  name: 'disablePayment',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    resetError(state) {
      state.error = undefined;
    },

    changeDisablePayment(
      state,
      action: PayloadAction<{ platform: DisablePaymentPlatforms; value: 1 | 0 }>
    ) {
      state.isLoading = false;
      if (state.disablePayment)
        state.disablePayment.data[action.payload.platform] = action.payload.value;
    },

    changeDisablePaymentVersion(
      state,
      action: PayloadAction<{ platform: DisablePaymentPlatformsVersion; value: string }>
    ) {
      state.isLoading = false;
      if (state.disablePayment)
        state.disablePayment.data[action.payload.platform] = action.payload.value;
    },

    getDisablePaymentSuccess(state, action: PayloadAction<DisablePayment>) {
      state.isLoading = false;
      state.disablePayment = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  hasError,
  resetError,
  changeDisablePayment,
  changeDisablePaymentVersion,
  getDisablePaymentSuccess,
} = slice.actions;
